import List from 'ln/list/List';
import SequenceBase from './SequenceBase';
import UserFileModel from './UserFileModel';
import { ISlide } from '../slideview/SlideDetailView';
import { backend } from '../../setup';

class UserSequenceModel extends SequenceBase {

	static getInstance( origin ){
		return new UserSequenceModel({
			origin: origin,
			userfiles: new List<UserFileModel>(),
			modelName:"App\\UserSequence",
		});
	}

	constructor( json:Object ){
		super( json );	
	}

	get ivr_goal():string {
		return this.get<string>( 'ivr_goal' );
	}

	get src_goal():string {
		return this.get<string>( 'src_goal' );
	}
	
	get endbehaviour():string {
		return this.get<string>( 'endbehaviour' );	
	}
	
	get teacher_directions():string {
		return this.get<string>( 'teacher_directions' );	
	}

	get method():string {
		return this.get<string>( 'method' );	
	}

	get socialform():string {
		return this.get<string>( 'socialform' );	
	}

	get material():string {
		return this.get<string>( 'material' );	
	}
	
	get note():string {
		return this.get<string>( 'note', '' );
	}
	
	set note( note:string ){
		this.set( 'note', note );	
	}

	get userfiles():List<UserFileModel>{
		return this.get<List<UserFileModel>>( 'userfiles' );
	}

	set userfiles( userfiles:List<UserFileModel> ){
		this.set( 'userfiles', userfiles );
	}

	get slides():List<ISlide>{
		return this.get<List<ISlide>>( 'slides' );
	}

	set slides( slides:List<ISlide> ){
		this.set( 'slides', slides );
	}
	
}

export default UserSequenceModel;


backend.mapper.toModel.add( 'App\\UserSequence', function( json:any ) {
	
	var sequence = new UserSequenceModel( json );
	
	sequence.userfiles = new List<UserFileModel>( json.userfiles );

	return sequence;	
});

backend.mapper.toModel.alias( 'App\\UserSequencePreview', 'App\\UserSequence' );

backend.mapper.toJson.add( 'App\\UserSequence', function( model:UserSequenceModel){
	var clone = model.object();
	clone['userfiles'] = model.userfiles ? backend.mapper.json( model.userfiles.all() ) : [];
	return clone;
});

